import { twoButtonModalStyles } from "@insite/content-library/Components/TwoButtonModal";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";


twoButtonModalStyles.submitButton = {
    variant: "secondary",
    css: css`
       border: 2px solid ${getColor("primary")} !important;
    `,
};